import React from 'react';
import {CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import Translate, {t} from "../../../../../../../components/Translate";
import {peakHoursToUserTime} from '../../../../../../../utils/DateUtils';

const formatStatus = (value, user) => t({text: value, user});

const CustomTooltip = ({active, payload, label, user}) => {
    if (active && payload && payload.length) {
        return (
            <div style={{backgroundColor: 'var(--ds-bg-primary)', padding: '10px', border: '1px solid #ccc'}}>
                <p>{label}</p>
                {payload.map((entry, index) => (
                    <p key={`item-${index}`} style={{color: entry.color}}>
                        {formatStatus(entry.name, user)} : {entry.value}
                    </p>
                ))}
            </div>
        );
    }

    return null;
};

const PeakHoursStatistics = ({data, user}) => {
    const localData = peakHoursToUserTime(data);
    return (
        <div style={{width: '100%', height: '400px'}}>
            <ResponsiveContainer width="100%" height="90%">
                <LineChart width={500} height={300} data={localData}>
                    <CartesianGrid strokeDasharray="3 3"/>
                    <XAxis dataKey="name" padding={{left: 30, right: 30}}/>
                    <YAxis/>
                    <Tooltip content={(props) => <CustomTooltip {...props} user={user}/>}/>
                    <Line type="monotone" dataKey="count" stroke="#8884d8" activeDot={{r: 8}}/>
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default PeakHoursStatistics;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/statistics/components/graphs/PeakHoursStatistics.jsx